import { Component, OnInit } from '@angular/core';
import { HolidayService } from '../service/holiday.service';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-holidays-list',
  templateUrl: './holidays-list.component.html',
  styleUrls: ['./holidays-list.component.css']
})
export class HolidaysListComponent implements OnInit {
  holidays = [];
  search;
  status = "active";
  preCooperates:any;
  constructor(
    private corporateService : CorporateService,
    private holidayService : HolidayService
  ) { }

  ngOnInit() {
    this.getcorporateUsers();
    this.getHolidaysData();
  }

  getHolidaysData(){
    const queryParams = {
      status: this.status
    }
    this.holidayService.getHolidaysList(queryParams).subscribe((data)=>{
      if(data){
        this.holidays= data;
      }
    })
  }
  onChangeStatus(evt) {
    this.getHolidaysData();
  }

  getcorporateUsers() {
    this.corporateService
      .getCorporateUsers(this.status)
      .subscribe(data => {
        if (data && data.length) {
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {})
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

}
